import { useEffect, useState, useRef } from 'react';

function formatTimeLeft(seconds) {
  if (seconds <= 0) return '0min 0sec';

  const d = Math.floor(seconds / 86400);
  const h = Math.floor((seconds % 86400) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;

  if (seconds >= 86400) {
    return `${d}d ${h}h ${m}m`;
  }
  if (seconds >= 3600) {
    return `${h}h ${m}min ${s}sec`;
  }
  return `${m}min ${s}sec`;
}

function useCountdownTimer(initialSeconds) {
  const [remainingSeconds, setRemainingSeconds] = useState(initialSeconds ?? 0);
  const intervalRef = useRef(null);
  const targetTsRef = useRef(null);

  // whenever initialSeconds changes, recompute the absolute deadline
  useEffect(() => {
    const secs = Number.isFinite(initialSeconds) ? Math.max(initialSeconds, 0) : 0;
    targetTsRef.current = Date.now() + secs * 1000;
    // immediately update the remaining time based on wall-clock
    const remaining = Math.max(Math.floor((targetTsRef.current - Date.now()) / 1000), 0);
    setRemainingSeconds(remaining);
  }, [initialSeconds]);

  useEffect(() => {
    // use a steady 1s tick
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(() => {
      const target = targetTsRef.current;
      if (!target) return;
      const remaining = Math.max(Math.floor((target - Date.now()) / 1000), 0);
      setRemainingSeconds(remaining);
    }, 1000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  return formatTimeLeft(remainingSeconds);
}

export default useCountdownTimer;
